import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "card card-flush pt-3 mb-5 mb-lg-10" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "card-title" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "fw-bolder" }, "Sipariş Listesi")
], -1)
const _hoisted_4 = { class: "card-toolbar" }

import { defineComponent, ref, computed } from "vue";

import Breadcrumb from 'primevue/breadcrumb';
import { useStore } from "vuex";
import { Actions } from "@/store/enums/StoreEnums";
import List from "./components/List.vue";
import Add from "./components/Add.vue";
//import { components } from "@/assets/ts";
import { useRouter, useRoute } from "vue-router";
import JwtService from "@/core/services/JwtService";
//JSON.parse(JwtService.getUser()).roles.find(x => x.id != 2)

export default /*#__PURE__*/_defineComponent({
  __name: 'Index',
  setup(__props) {

const router = useRouter();
const store = useStore();
const isActive = ref(false);

const redirectAdd = () => {
  router.push({ name: "order-add" });
}
store.dispatch(Actions.ADD_BODY_CLASSNAME, "page-loading");
store.dispatch(Actions.ORDER_LIST, {page:1}).then((f) => {
  store.dispatch(Actions.REMOVE_BODY_CLASSNAME, "page-loading");
});

return (_ctx: any,_cache: any) => {
  const _component_Toast = _resolveComponent("Toast")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Toast),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          (JSON.parse(_unref(JwtService).getUser()).roles.find(x => x.id != 3))
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                class: "btn btn-light-primary",
                style: {"border":"1px solid #eee"},
                onClick: _cache[0] || (_cache[0] = ($event: any) => (redirectAdd()))
              }, " Yeni Oluştur "))
            : _createCommentVNode("", true)
        ])
      ]),
      (_unref(store).state.OrderModule.order.value)
        ? (_openBlock(), _createBlock(List, { key: 0 }))
        : _createCommentVNode("", true)
    ])
  ], 64))
}
}

})